var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "text-count",
      style: _vm.styles,
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
        select: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("div", { attrs: { "data-test": "name" } }, [
        _vm._v("\n    " + _vm._s(_vm.name)),
        _vm.tooltip
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: { content: _vm.tooltip },
                    expression: "{ content: tooltip }",
                  },
                ],
                staticClass: "pega-circle",
                attrs: { "data-test": "tooltip" },
              },
              [_vm._v("?")]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.max
        ? _c("div", { attrs: { "data-test": "length" } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.textLength) +
                "/" +
                _vm._s(_vm.max) +
                "文字\n  "
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }